import { render, staticRenderFns } from "./Notification.vue?vue&type=template&id=008d2d66&scoped=true"
import script from "./Notification.vue?vue&type=script&lang=js"
export * from "./Notification.vue?vue&type=script&lang=js"
import style0 from "./Notification.vue?vue&type=style&index=0&id=008d2d66&prod&scoped=true&lang=css"
import style1 from "./Notification.vue?vue&type=style&index=1&id=008d2d66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008d2d66",
  null
  
)

export default component.exports